import '../../modules/mode-components';

import * as angular from 'angular';
import * as $ from 'jquery';

function reportDragDirective() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      const elem = element[0];
      elem.draggable = true;

      elem.addEventListener(
        'dragstart',
        function (e) {
          const $dragElem = $('<div class="report-drag-element">');
          const text = document.createTextNode(attrs.reportName);
          $dragElem[0].appendChild(text);
          $('body').append($dragElem);

          e.dataTransfer.effectAllowed = 'move';
          e.dataTransfer.setData('Text', this.id);
          e.dataTransfer.setDragImage($dragElem[0], 0, 0);
          this.classList.add('drag');
          return false;
        },
        false
      );

      elem.addEventListener(
        'dragend',
        function (e) {
          $('body').find('.report-drag-element').remove();
          this.classList.remove('drag');
          return false;
        },
        false
      );
    },
  };
}

angular.module('mode.components').directive('reportDrag', reportDragDirective);
